// extracted by mini-css-extract-plugin
export default {"noDataDiv":"EmptyInbox_noDataDiv__VPS4G","noData-Img":"EmptyInbox_noData-Img__O+ll5","noData-title":"EmptyInbox_noData-title__bhCHy","noData-text":"EmptyInbox_noData-text__IaEag"};